import { useState } from "react";

export const useThrowAsyncError = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setState] = useState();

  return (error: Error) => {
    setState(() => {
      throw error;
    });
  };
};
